<h2>Información</h2>
<mat-dialog-content>
  {{ data || 'Lo sentimos hubo un error al obtener la cotización.' }}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>
